/**
 *
 * @module price
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class Price
 *
 */
export default class Price {

    /**
     *
     * @param {Object} options
     * @param {Number} options.discountAmount
     * @param {Number} options.subtotalAmount
     * @param {Number} options.taxAmount
     * @param {Number} options.totalAmount
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'Price(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get discountAmount() {
                return `${this.ctor} options.discountAmount should be a Number`;
            },
            get subtotalAmount() {
                return `${this.ctor} options.subtotalAmount should be a Number`;
            },
            get taxAmount() {
                return `${this.ctor} options.taxAmount should be a Number`;
            },
            get totalAmount() {
                return `${this.ctor} options.totalAmount should be a Number`;
            }
        };


        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { discountAmount, subtotalAmount, taxAmount, totalAmount } = options;

        number(discountAmount, errorMessage.discountAmount, InvalidArgumentException);
        number(subtotalAmount, errorMessage.subtotalAmount, InvalidArgumentException);
        number(taxAmount, errorMessage.taxAmount, InvalidArgumentException);
        number(totalAmount, errorMessage.totalAmount, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.discountAmount = discountAmount;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.subtotalAmount = subtotalAmount;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.taxAmount = taxAmount;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.totalAmount = totalAmount;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/price.js